import { axios } from '@argon/app/axios'

const NAMESPACE = 'addons'

const state = {
  items: {},
  itemsCount: {},
  itemsPagination: {},
  labels: []
}

const mutations = {
  SET_ITEMS: (state, payload) => {
    state.items = payload
  },
  SET_ITEMS_COUNT: (state, payload) => {
    state.itemsCount = payload
  },
  SET_LABELS: (state, payload) => {
    state.labels = payload
  },
  SET_ITEMS_PAGINATION: (state, payload) => {
    state.itemsPagination = payload
  }
}

const actions = {
  clearAddons: ({ commit, state }, { addon }) => {
    return new Promise((resolve, reject) => {
      const items = { ...state.items }
      items[addon] = []
      commit('SET_ITEMS', items)
      resolve(true)
    })
  },
  listEntityAddons: ({ commit, state }, payload) => {
    const { entityURL, addon, pager } = payload
    let pagerParams = pager || state.itemsPagination[addon]
    let params = { include: 'owner', ...pagerParams }
    let url = `${entityURL}/${addon}`
    return new Promise((resolve, reject) => {
      axios({
        url,
        params,
        method: 'GET'
      })
        .then(({ data }) => {
          const items = { ...state.items }
          const itemsCount = { ...state.itemsCount }
          const itemsPagination = { ...state.itemsPagination }
          items[addon] = data.items
          itemsCount[addon] = data.count
          itemsPagination[addon] = pager || state.itemsPagination[addon]
          commit('SET_ITEMS', items)
          commit('SET_ITEMS_COUNT', itemsCount)
          commit('SET_ITEMS_PAGINATION', itemsPagination)
          resolve(data.items)
        })
        .catch(reject)
    })
  },
  createEntityAddon: ({ dispatch }, payload) => {
    const { entityURL, addon, data } = payload
    let url = `${entityURL}/${addon}`
    return new Promise((resolve, reject) => {
      axios({
        url,
        data,
        method: 'POST'
      })
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  },
  updateEntityAddon: ({ dispatch }, payload) => {
    const { id, entityURL, addon, data } = payload
    let url = `${entityURL}/${addon}/${id}`
    return new Promise((resolve, reject) => {
      axios({
        url,
        data,
        method: 'PUT'
      })
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  },
  deleteEntityAddon: ({ dispatch, state }, payload) => {
    const { id, entityURL, addon } = payload
    let url = `${entityURL}/${addon}/${id}`
    return new Promise((resolve, reject) => {
      axios
        .delete(url)
        .then(() => {
          resolve(true)
        })
        .catch(reject)
    })
  },
  uploadFile: ({}, data) => {
    let url = '/files'
    return new Promise((resolve, reject) => {
      axios({
        url,
        data,
        method: 'POST'
      })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(reject)
    })
  },
  listLabels: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/labels')
        .then(({ data }) => {
          commit('SET_LABELS', data.items)
          resolve(data.items)
        })
        .catch(reject)
    })
  },
  createLabel: ({}, payload) => {
    const { data } = payload
    return new Promise((resolve, reject) => {
      axios({ url: '/labels', method: 'POST', data })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(reject)
    })
  }
}

const getters = {
  itemsList: (state) => (addonName) => state.items[addonName] || [],
  itemsCount: (state) => (addonName) => state.itemsCount[addonName] || null
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
export { NAMESPACE }
